export default __webpack_public_path__ + "static/media/bkoi_white.4c0f6c11.svg";